var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLogin)?_c('div',[(!_vm.isRoute(_vm.routes.login))?_c('v-btn',{attrs:{"to":_vm.route(_vm.routes.login),"text":"","tile":""}},[_vm._v("\n    "+_vm._s(_vm.$t('login'))+"\n  ")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }